import Vue from 'vue'

const UNPROCESSABLE_ENTITY = 422

export default function backendValidationErrorHandling(responseData, title) {
  const {
    response: { status, data },
  } = responseData
  if (status === UNPROCESSABLE_ENTITY) {
    const [_, [str]] = Object.entries(data).flat()

    Vue.notify({
      group: 'hasBottomNavigation',
      title: title,
      type: 'error',
      text: str,
    })
  }
}
